import React from "react";
import { Page } from "../../components/page/page";
import styles from "./elements.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setElements } from "../../store/stateSlice";

const options = [
  {
    value: "Fire",
    icon: "🔥",
  },
  {
    value: "Water",
    icon: "🌊",
  },
  {
    value: "Air",
    icon: "🌬️",
  },
  {
    value: "Earth",
    icon: "🌍",
  },
];

const ElementsPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Which element do you feel most aligned with?"
      hideContinueButton={true}
      currentStep={8}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../tradition"
              onClick={() => dispatch(setElements(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { ElementsPage };
